// extracted by mini-css-extract-plugin
module.exports = {"container":"_1wpF8Jueklyzs3HkfxqV58"};